import { useState, useEffect, useCallback, Suspense, useContext } from "react";
import { trackPromise } from "react-promise-tracker";
import { LazyVEBDependentBenefitsGrid } from "../../../..";
import { AuthContext, DependentContext } from "../../../../../../contexts";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import { VEBEnrollmentSchema } from "../../../../../../types/enrollment.types";
import { api } from "../../../../../../utils/api";
import { GetDependentBenefitsQuery } from "../../../../../../utils/api/enrollment/enrollment";
import { ThemeFormSubHeader } from "../../../../../shared/themeFormSubHeader";
import DependentBenefitsGrid from "./dependentBenefitsGrid/DependentBenefitsGrid";

const VEBDependentBenefits = ({ dependentDetails }: any) => {
	const [VEBDependentBenefits, setVEBDependentBenefits] = useState<VEBEnrollmentSchema[]>([]);
	const [currentVEBDependentBenefits, setCurrentVEBDependentBenefits] = useState<VEBEnrollmentSchema[]>([]);
	const [futureVEBDependentBenefits, setFutureVEBDependentBenefits] = useState<VEBEnrollmentSchema[]>([]);
	const { member } = useContext(AuthContext);
	const { dependent } = useContext(DependentContext);

	const getVEBBenefits = useCallback(async () => {
		if (member === null || (member?.role === "EMPLOYEE" && dependent === null) || !dependent) {
			return;
		}
		const getVEBDependentBenefitsQuery: GetDependentBenefitsQuery = {
			insured_SSN: member.role === "EMPLOYEE" ? member.SSN : member.employee_SSN,
			member_SSN: member.role === "EMPLOYEE" ? dependent.SSN : member.SSN,
			group_number: member.group_number
		};
		const _VEBDependentBenefits: VEBEnrollmentSchema[] = await trackPromise(
			api.enrollment.getVEBDependentBenefits(getVEBDependentBenefitsQuery)
		);
		const _currentVEBDependentBenefits: VEBEnrollmentSchema[] = [];
		const _futureVEBDependentBenefits: VEBEnrollmentSchema[] = [];
		_VEBDependentBenefits.forEach((VEBDependentBenefit: VEBEnrollmentSchema) => {
			if (true && new Date(VEBDependentBenefit.effective_date as any) <= new Date()) {
				_currentVEBDependentBenefits.push(VEBDependentBenefit);
			} else {
				_futureVEBDependentBenefits.push(VEBDependentBenefit);
			}
		});
		setCurrentVEBDependentBenefits(Object.assign([], _currentVEBDependentBenefits));
		setFutureVEBDependentBenefits(Object.assign([], _futureVEBDependentBenefits));
	}, [dependent, member]);

	useEffect(() => {
		getVEBBenefits();
	}, [getVEBBenefits]);

	// console.log(dependentDetails);

	return (
		<>
			<div className="VEB-benefits-container">
				<div className="pf-container-title">Current Benefits</div>
				<LazyVEBDependentBenefitsGrid benefits={currentVEBDependentBenefits} />
				<div className="pf-title">Future Benefits</div>
				<LazyVEBDependentBenefitsGrid benefits={futureVEBDependentBenefits} />
			</div>
		</>
	);
};

export default VEBDependentBenefits;
